import React from 'react';

/* Wordmark + kiwi mark lockup. Asset paths are resolved relative to the page,
   so pass `src` when the page is not at the project root. */
export function Logo({variant='full',size=28,tone='dark',src='assets/logo-mark-trim.png',srcWhite='assets/logo-mark-white.png',style,...rest}){
  const mark=React.createElement('img',{src:tone==='light'?srcWhite:src,alt:'KIVIN',style:{height:size,width:'auto'}});
  const word=React.createElement('span',{style:{fontFamily:'var(--font-display)',fontWeight:'var(--fw-semibold)',fontSize:size*0.62,letterSpacing:'0.02em',color:tone==='light'?'var(--white)':'var(--ink-950)',lineHeight:1}},'KIVIN');
  return React.createElement('span',{style:{display:'inline-flex',alignItems:'center',gap:size*0.34,...style},...rest},
    variant!=='wordmark'?mark:null, variant!=='mark'?word:null);
}
